import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://wlsnnjhpkbvklqpjrzcw.supabase.co";
const SUPABASE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indsc25uamhwa2J2a2xxcGpyemN3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjcxNTE3OTYsImV4cCI6MjA0MjcyNzc5Nn0.GAe-5ibA7p5WAcZe65CFXzD-pkiCaWg0Zf9n-k-cekk";

const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

export default supabase;
